import {GET_MUST_CHANGE_PASSWORD} from 'shared/constants/ActionTypes';

const setForm = (payload) => {
  return {
    type: GET_MUST_CHANGE_PASSWORD,
    payload,
  };
};

export const setMustChangePasswordStatus = (payload) => {
  return (dispatch) => {
    dispatch(setForm(payload));
  };
};
